// test52
(52 && 0);
